"use strict";
/**** resources *****
 http://jdewit.github.io/bootstrap-timepicker/ -  timepicker
 https://angular-ui.github.io/bootstrap/ -  date picker
 *********************/

//This overrides the default minuteStep from bootstrap-timepicker
$.fn.timepicker.defaults.minuteStep = 1;

var dateTimePickerDirectives = angular.module('dateTimePickerDirective', []);

dateTimePickerDirectives.directive('dateTimePicker', ['clockService','dateFilter', function (clockService, dateFilter) {

    return {
        restrict: 'E',
        scope: {
            defaultValue: '=defaultValue',
            minDateTime: '=minDate',
            maxDateTime: '=maxDate',
            onDateChange: '&'
        },
        templateUrl: 'js/directives/templates/dateTimePicker.tpl.html',
        link: function (scope, element, attrs) {
            clockService.getTime().then(function (response) {
                if(scope.$parent.$parent.signInTime) {
                    scope.dt = scope.$parent.$parent.signInTime;
                } else {
                    scope.dt = clockService.getTimeFromString(response.storeTime);
                }

                $('#timepicker').timepicker("setTime",dateFilter(scope.dt, "HH:mm"));
            });
        },
        controller: ['$scope', function ($scope) {
            $scope.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd/MM/yyyy', 'shortDate'];
            clockService.getAppDateFormat().then(function (response) {
                var dateTimeFormat = response.dateTimeFormat;
                $scope.format = dateTimeFormat.substring(0, dateTimeFormat.indexOf(' '));
            });
            $scope.today = function () {
                $scope.dt = new Date();
            };


            $scope.clear = function () {
                $scope.dt = null;
            };

            // Disable weekend selection
            $scope.disabled = function (date, mode) {
                return ( mode === 'day' && ( date.getDay() === 0 || date.getDay() === 6 ) );
            };

            $scope.open = function ($event) {
                $scope.minDate = $scope.minDateTime;
                $scope.maxDate = $scope.maxDateTime
                $event.preventDefault();
                $event.stopPropagation();

                $scope.opened = true;
            };

            $scope.openTimePicker = function ($event) {
                $event.preventDefault();
                $event.stopPropagation();

                $('#timepicker').timepicker('showWidget');
            };

            $scope.dateOptions = {
                formatYear: 'yy',
                startingDay: 1,
                minDate: $scope.minDate
            };

            $scope.$watch('dt', function (newValue, oldValue) {
                if(newValue !== undefined || newValue !== undefined) {
                    $scope.onDateChange()(newValue);
                    $scope.dt = newValue;
                }
            });

            $('#timepicker').timepicker({

                showInputs: true,
                disableFocus: true,
                showMeridian:false
            });

            $('#timepicker').timepicker().on('changeTime.timepicker', function (e) {
                var hours = e.time.hours;

                $scope.dt.setHours(hours);
                $scope.dt.setMinutes(e.time.minutes);
                if($scope.dt !== undefined || $scope.dt !== null) {
                    $scope.onDateChange()($scope.dt);
                }
            });
        }]
    };

}]);
